import React from 'react';

import {CABINET_BATHROOM_LABELS, CABINET_LABELS} from "../../../../../../constants";

const CABINET_PARENT_PART_IDS = [
  CABINET_LABELS.top_cabinet,
  CABINET_LABELS.bottom_cabinet,
  CABINET_LABELS.tall_cabinet,
  CABINET_BATHROOM_LABELS.vanity_cabinet,
];

const getUnavailableMessage = ({intl, partId, isMissingParentFeature}) => {
  const isCabinetParentPart = CABINET_PARENT_PART_IDS.includes(partId);

  if (isMissingParentFeature && isCabinetParentPart) {
    return {
      title: intl.formatMessage({
        id: "sqft.navigation.cabinet3d.select_available_color_title",
        defaultMessage: "Select an available cabinet color"
      }),
      description: intl.formatMessage({
        id: "sqft.navigation.cabinet3d.select_available_color_description",
        defaultMessage: "Choose a cabinet color that supports 3D cabinets to see available options."
      }),
    };
  }

  if (isCabinetParentPart) {
    return {
      title: intl.formatMessage({
        id: "sqft.navigation.cabinet3d.no_cabinets_title",
        defaultMessage: "No 3D cabinets available"
      }),
      description: intl.formatMessage({
        id: "sqft.navigation.cabinet3d.no_cabinets_description",
        defaultMessage: "Choose another cabinet color to see cabinets that can be added to the 3D scene."
      }),
    };
  }

  return {
    title: intl.formatMessage({
      id: "sqft.navigation.related_options.no_options_title",
      defaultMessage: "No options available"
    }),
    description: intl.formatMessage({
      id: "sqft.navigation.related_options.no_options_description",
      defaultMessage: "There are no available options for the current selection."
    }),
  };
};

const SqftRelatedOptionsUnavailableMessage = ({intl, partId, isMissingParentFeature}) => {
  const unavailableMessage = getUnavailableMessage({
    intl,
    partId,
    isMissingParentFeature,
  });

  return (
    <div className="sqft-cabinet-unavailable">
      <div className="sqft-cabinet-unavailable__title">{unavailableMessage.title}</div>
      <div className="sqft-cabinet-unavailable__description">{unavailableMessage.description}</div>
    </div>
  );
};

export default SqftRelatedOptionsUnavailableMessage;
